export default "__VITE_ASSET__BB9u2xQh__"